import React from 'react';
import QuoteDisplay from '../components/QuoteDisplay';

function QuotePage() {
  return (
    <div className="quote-page">
      <QuoteDisplay />
    </div>
  );
}

export default QuotePage;
